import { FormGroup, Input, Label } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { NumericFormat } from "react-number-format";
import { DataTableShell } from "../common/DataTableShell";

export const DataByCountryForm = ({
  aditionalData,
  setAditionalData,
  handleRemoveCountry,
}) => {
  const navigate = useNavigate();
  const { getData } = useDataFetch();
  const { data: dataCountries } = getData(
    ["countries"],
    "/product/countries-available/all"
  );

  const {
    control,
    handleSubmit,
    trigger,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country_id: "",
      currency: "",
      price_local_currency: "",
      price_usdt: "",
      delivery_time_days: "",
      loyalty_points: "",
      influencer_bonus: "",
    },
  });

  const onSubmit = async (data) => {
    const exists = aditionalData.some((item) => item.country_id === data.country_id);
    if (exists) {
      toast.error("Este país ya fue agregado.");
      return;
    }

    setAditionalData([...aditionalData, data]);
    toast.success("País agregado correctamente.");
    reset();
  };

  const renderCurrencyInput = (field, name, invalid) => (
    <NumericFormat
      {...field}
      className={`form-control${invalid ? " is-invalid" : ""}`}
      thousandSeparator="."
      decimalSeparator=","
      prefix="$ "
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      onValueChange={(values) => field.onChange(values.floatValue)}
      onBlur={() => trigger(name)}
    />
  );

  const errorMsg = (err) => err && <div style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>{err.message}</div>;

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 4px", fontSize: 16, fontWeight: 700 }}>Datos por país</h3>
      <p style={{ margin: "0 0 18px", color: "#8A91AE", fontSize: 11.5 }}>
        Precio, puntos y tiempo de entrega cambian por país. Agrega uno a la vez.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <FormGroup className="mb-0">
          <Label>País</Label>
          <Controller
            name="country_id"
            control={control}
            rules={{ required: "Selecciona un país" }}
            render={({ field }) => (
              <Input
                type="select"
                invalid={!!errors.country_id}
                {...field}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  const selected = dataCountries?.data?.countries.find((c) => c.id === e.target.value);
                  if (selected) setValue("currency", selected.currency || "");
                }}
                onBlur={() => trigger("country_id")}
              >
                <option value="">Selecciona</option>
                {dataCountries?.data?.countries.map((country) => (
                  <option key={country.id} value={country.id}>{country.name}</option>
                ))}
              </Input>
            )}
          />
          {errorMsg(errors.country_id)}
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Moneda local</Label>
          <Controller
            name="currency"
            control={control}
            render={({ field }) => <Input {...field} type="text" readOnly disabled />}
          />
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Precio Local</Label>
          <Controller
            name="price_local_currency"
            control={control}
            rules={{ required: "Campo obligatorio", min: { value: 0, message: "Debe ser >= 0" } }}
            render={({ field }) => renderCurrencyInput(field, "price_local_currency", !!errors.price_local_currency)}
          />
          {errorMsg(errors.price_local_currency)}
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Precio USDT</Label>
          <Controller
            name="price_usdt"
            control={control}
            rules={{ required: "Campo obligatorio", min: { value: 0, message: "Debe ser >= 0" } }}
            render={({ field }) => renderCurrencyInput(field, "price_usdt", !!errors.price_usdt)}
          />
          {errorMsg(errors.price_usdt)}
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Regalía</Label>
          <Controller
            name="loyalty_points"
            control={control}
            rules={{ required: "Campo obligatorio", min: { value: 0, message: "Debe ser >= 0" } }}
            render={({ field }) => <Input type="number" invalid={!!errors.loyalty_points} {...field} onBlur={() => trigger("loyalty_points")} />}
          />
          {errorMsg(errors.loyalty_points)}
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Bono influencer</Label>
          <Controller
            name="influencer_bonus"
            control={control}
            rules={{ required: "Campo obligatorio", min: { value: 0, message: "Debe ser >= 0" } }}
            render={({ field }) => <Input type="number" invalid={!!errors.influencer_bonus} {...field} onBlur={() => trigger("influencer_bonus")} />}
          />
          {errorMsg(errors.influencer_bonus)}
        </FormGroup>

        <FormGroup className="mb-0">
          <Label>Días de entrega</Label>
          <Controller
            name="delivery_time_days"
            control={control}
            rules={{ required: "Campo obligatorio", min: { value: 0, message: "Debe ser >= 0" } }}
            render={({ field }) => <Input type="number" invalid={!!errors.delivery_time_days} {...field} onBlur={() => trigger("delivery_time_days")} />}
          />
          {errorMsg(errors.delivery_time_days)}
        </FormGroup>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <button
            type="button"
            onClick={handleSubmit(onSubmit)}
            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 7, border: "none", background: "#4B36F0", color: "#fff", borderRadius: 9, padding: "11px 0", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
          >
            <i className="ri-add-line" /> Agregar país
          </button>
        </div>
      </div>

      <div style={{ marginTop: 22 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 11 }}>
          <h4 style={{ margin: 0, fontSize: 13.5, fontWeight: 700 }}>Países agregados</h4>
          <span style={{ color: "#8A91AE", fontSize: 12 }}>{aditionalData.length} países</span>
        </div>

        <DataTableShell
          minWidth={660}
          empty={aditionalData.length === 0}
          emptyMessage="No hay países agregados."
          headers={
            <>
              <th>País</th>
              <th>Moneda</th>
              <th style={{ textAlign: "right" }}>Precio local</th>
              <th style={{ textAlign: "right" }}>USDT</th>
              <th style={{ textAlign: "center" }}>Días</th>
              <th style={{ textAlign: "center" }}>Regalía</th>
              <th style={{ textAlign: "center" }}>Bono</th>
              <th></th>
            </>
          }
        >
          {aditionalData.map((item, idx) => {
            const country = dataCountries?.data?.countries.find((c) => c.id === item.country_id);
            return (
              <tr key={idx}>
                <td style={{ fontWeight: 600 }}>{country?.name ?? "N/A"}</td>
                <td style={{ fontFamily: "'JetBrains Mono',monospace", color: "#5A6187", fontSize: 11.5 }}>{item.currency}</td>
                <td style={{ textAlign: "right", fontWeight: 600, whiteSpace: "nowrap" }}>{item.price_local_currency}</td>
                <td style={{ textAlign: "right", color: "#5A6187", whiteSpace: "nowrap" }}>{item.price_usdt}</td>
                <td style={{ textAlign: "center", color: "#5A6187" }}>{item.delivery_time_days}</td>
                <td style={{ textAlign: "center", color: "#5A6187" }}>{item.loyalty_points}</td>
                <td style={{ textAlign: "center", color: "#5A6187" }}>{item.influencer_bonus}</td>
                <td style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={() => handleRemoveCountry(idx)}
                    style={{ width: 28, height: 26, border: "1px solid #F6C9C9", borderRadius: 7, background: "#fff", color: "#DC2626", cursor: "pointer" }}
                  >
                    <i className="ri-delete-bin-line" style={{ fontSize: 13 }} />
                  </button>
                </td>
              </tr>
            );
          })}
        </DataTableShell>
      </div>

      <div style={{ display: "flex", gap: 11, marginTop: 22, paddingTop: 18, borderTop: "1px solid #EDEFF6" }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{ border: "1px solid #E1E4F0", background: "#fff", color: "#3B4266", borderRadius: 9, padding: "12px 20px", fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, cursor: "pointer" }}
        >
          Cancelar
        </button>
        <button
          type="submit"
          style={{ flex: 1, border: "none", background: "#4B36F0", color: "#fff", borderRadius: 9, padding: "12px 0", fontFamily: "inherit", fontSize: 13.5, fontWeight: 700, cursor: "pointer" }}
        >
          Guardar producto
        </button>
      </div>
    </div>
  );
};
